<div class="container">

    <div class="text-head">
        <h1>No posee permisos suficientes para visualizar este contenido, contacte con el administrador</h1>
    </div>

</div>